import '../styles/stack.scss'
import Skill from './Skill'

import { skills } from '../constants/constants'

import { FavoriteTools } from '../constants/constants'

import { useSelector } from 'react-redux'

const Stack = () => {

    //Setting up a hook on current language
    const storeCurrentLanguage = state => state.language;
    const currentLanguage = useSelector(storeCurrentLanguage);

    const renderedSkills = skills.map( skill => {
        return <Skill name={skill.name} description = {skill.description} image = {skill.image}/>
    })
    return  <div className = 'stack'>
            <div className = 'stack__title'>{FavoriteTools[currentLanguage]}</div>
          {renderedSkills}
    </div>
}
export default Stack